import {combineReducers} from 'redux';
import loaderCsvFormReducer from './csv-form/reducer';
import loaderXmlFormReducer from './xml-form/reducer';
import {LOADER_CC_SET, LOADER_CCS_HIDE, LOADER_CCS_READ, LOADER_FORMAT_SET, LOADER_CC_VALIDATION_FILE_UPLOAD,LOADER_CC_FILE_SET, LOADER_CONFIGURED_PLUGINS } from "./actions";
import {REQUEST_SUCCESS, REQUEST_START } from "../../../middlewares/api/actions";
import {getArtefactFromSdmxJsonStructure, getSdmxStructuresFromSdmxJson} from "../../../utils/sdmxJson";
import {getCurrentNodeConfig} from "../../../middlewares/current-node-config/middleware";
import {LOADER_XML_FORM_CUBE_UNSET, LOADER_XML_FORM_SUBMIT} from "./xml-form/actions";
import {LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET} from "./csv-form/mapping-control/actions";
import {LOADER_CSV_FORM_SEQUENCE_MAPPING_SUBMIT, LOADER_CSV_FORM_SUBMIT} from "./csv-form/actions";


const loaderReducer = combineReducers({
  components: combineReducers({
    csvForm: loaderCsvFormReducer,
    xmlForm: loaderXmlFormReducer,
  }),
  shared: (
    state = {
      format: 'csv',
      ccs: null,
      cc: null,
      ccFile: null,
      ccFileServerPath :null,
      ccData:null,
    },
    action
  ) => {
    switch (action.type) {
      case LOADER_FORMAT_SET:
        return {
          ...state,
          format: action.format,
          ccs: null,
          cc: null,
          ccFileServerPath :null,
          ccData:null
        };
      case LOADER_CCS_HIDE:
        return {
          ...state,
          ccs: null
        };
      case LOADER_CC_SET:
        return {
          ...state,
          ccs: null,
          cc: action.ccTriplet
        };
      case LOADER_CC_FILE_SET:
        return {
          ...state,
          ccFile: action.ccFile,
          ccData:null,
          ccFileServerPath: null,
        };
      case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET:
      case LOADER_XML_FORM_CUBE_UNSET:
        return {
          ...state,
          cc: null,
          ccFile: null,
          ccFileServerPath: null,
          ccData:null
        };
  
      case REQUEST_START:
        switch (action.label) {
          case LOADER_CC_VALIDATION_FILE_UPLOAD:
            return {
              ...state,
              ccFileServerPath: null,
              ccData: null,
            };

          default:
            return state;
        }
      case REQUEST_SUCCESS:
        switch (action.label) {
          case LOADER_CCS_READ:
            return {
              ...state,
              ccs: (getSdmxStructuresFromSdmxJson(action.response) || [])
                .map(artefact => getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
            };
          case LOADER_CC_VALIDATION_FILE_UPLOAD:
            return {
              ...state,
              ccFileServerPath: action.response.filePath,
              ccData: action.response.importedItem.filter(
                (e) => e.type === "contentconstraint"
              ).length,
            };
          case LOADER_CSV_FORM_SUBMIT:
          case LOADER_XML_FORM_SUBMIT:
          case LOADER_CSV_FORM_SEQUENCE_MAPPING_SUBMIT:
            return {
              ...state,
              cc: null,
              ccFile: null,
              ccFileServerPath:null,
              ccData:null
            };
          case LOADER_CONFIGURED_PLUGINS:
            return {
              ...state,
              configuredPlugins: action.response
            }
            default:
            return state;
        }
      default:
        return state;
    }
  }
});

export default loaderReducer;
